import * as mutations from '../../mutation-types'

export const processProjectContact = (store, {project_id, contact_id, role}) => {
    store.commit(mutations.ATTACH_PROJECT_CONTACT, {project_id, contact_id, role})
}

export const attachProjectContact = (store, {project_id, contact_id, role}) => {
    axios.post(`/api/projects/${project_id}/contacts/${contact_id}`, {role: role})
        .then(res => {
            store.dispatch('processContact', res.data.data)
            processProjectContact(store, {project_id, contact_id, role})
            return res
        })
}

export const detachProjectContact = (store, {project_id, contact_id}) => {
    axios.delete(`/api/projects/${project_id}/contacts/${contact_id}`)
        .then(res => {
            store.commit(mutations.DETACH_PROJECT_CONTACT, {project_id, contact_id})
            return res
        })
}
